import React, { useEffect } from "react";
import { STYLE_PREFIX } from "../../../../utils/const";
import "./style.less";
var PicModal = function PicModal(props) {
  var _messageInfo$extraSty5, _messageInfo$extraSty6, _messageInfo$extraSty7, _messageInfo$extraSty8;
  useEffect(function () {
    document.body.style.overflow = 'hidden';
    return function () {
      document.body.style.overflow = '';
    };
  }, []);
  var messageInfo = props.messageInfo,
    cancel = props.cancel;
  var handleDetail = function handleDetail() {
    var _messageInfo$extraSty, _messageInfo$extraSty2, _messageInfo$extraSty3, _messageInfo$extraSty4;
    if (!((_messageInfo$extraSty = messageInfo.extraStyle) !== null && _messageInfo$extraSty !== void 0 && (_messageInfo$extraSty2 = _messageInfo$extraSty.popupsConfig) !== null && _messageInfo$extraSty2 !== void 0 && _messageInfo$extraSty2.jumpUrl)) return;
    window.open((_messageInfo$extraSty3 = messageInfo.extraStyle) === null || _messageInfo$extraSty3 === void 0 ? void 0 : (_messageInfo$extraSty4 = _messageInfo$extraSty3.popupsConfig) === null || _messageInfo$extraSty4 === void 0 ? void 0 : _messageInfo$extraSty4.jumpUrl);
    cancel === null || cancel === void 0 ? void 0 : cancel(messageInfo.id);
  };
  return /*#__PURE__*/React.createElement("div", {
    className: "".concat(STYLE_PREFIX, "message-modal-pic")
  }, /*#__PURE__*/React.createElement("div", {
    className: 'overlay'
  }), /*#__PURE__*/React.createElement("div", {
    className: 'popup'
  }, /*#__PURE__*/React.createElement("img", {
    src: messageInfo === null || messageInfo === void 0 ? void 0 : (_messageInfo$extraSty5 = messageInfo.extraStyle) === null || _messageInfo$extraSty5 === void 0 ? void 0 : (_messageInfo$extraSty6 = _messageInfo$extraSty5.popupsConfig) === null || _messageInfo$extraSty6 === void 0 ? void 0 : _messageInfo$extraSty6.imageUrl,
    alt: "",
    className: 'img',
    onClick: handleDetail,
    style: {
      cursor: (_messageInfo$extraSty7 = messageInfo.extraStyle) !== null && _messageInfo$extraSty7 !== void 0 && (_messageInfo$extraSty8 = _messageInfo$extraSty7.popupsConfig) !== null && _messageInfo$extraSty8 !== void 0 && _messageInfo$extraSty8.jumpUrl ? 'pointer' : ''
    }
  }), /*#__PURE__*/React.createElement("div", {
    className: 'close_icon',
    onClick: function onClick() {
      return cancel === null || cancel === void 0 ? void 0 : cancel(messageInfo.id);
    }
  })));
};
export default PicModal;